import React, { useEffect, useState } from 'react';
import { ReactSession } from "react-client-session";



export default function Principal() {
  const [hora, setHora] = useState(new Date());
  const [modo, setModo] = useState("principal"); 
  const [tipoMarca, setTipoMarca] = useState(""); 
  const [sucursalesCalculadas, setSucursalesCalculadas] = useState([]);
  const [mensajeError, setMensajeError] = useState(""); 
  const [desfase, setDesfase] = useState(0); 
  const [sucursalesBase, setSucursalesBase] = useState([]); 
  const [ubicacionActual, setUbicacionActual] = useState(null); 
  const [cargando, setCargando] = useState(true);
  const [mostrarDialogo, setMostrarDialogo] = useState(false);
  const [textoDialogo, setTextoDialogo] = useState("");
  const [resolverDialogo, setResolverDialogo] = useState(null);
  const [mostrarCodigo, setMostrarCodigo] = useState(false);
  const [codigoConfirmacion, setCodigoConfirmacion] = useState("");
  const [procesoMarcacion, setProcesoMarcacion] = useState(null);
  const [intentos,setIntentos] = useState(3);


  const server = process.env.REACT_APP_SERVER;
  const modulo = Number(process.env.REACT_ID_MODULO);

  // 1. SINCRONIZACIÓN INICIAL (Hora y Sucursales)
  useEffect(() => {
    const inicializarApp = async () => {
      setCargando(true);
      try {
        await Promise.all([sincronizarReloj(), cargarSucursales()]);
      } catch (error) {
        console.error("Error en la carga inicial:", error);
      } finally {
        setCargando(false);
      }
    };
    inicializarApp();
  }, []);

  const sincronizarReloj = async () => {
    try {
      const response = await fetch(`${server}/api/asistencia/obtener-hora`);
      const data = await response.json();
      const ahoraLocal = Date.now();
      const diferencia = data.serverTime - ahoraLocal;
      setDesfase(diferencia);
    } catch (error) {
      console.error("Error sincronizando reloj:", error);
    }
  };

  const cargarSucursales = async () => {
    try {
      const regional = Number(JSON.parse(localStorage.getItem("info")).ID_REGIONAL_ACTUAL);
      const response = await fetch(`${server}/sqlComun/getSucursalesParaMarcar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ regional })
      });
      const data = await response.json();
      //console.log('Lista de sucursales: ', JSON.stringify(data));
      if (data.ok) {
        const mapeadas = data.data
          .filter(s => (s.GEO_LATITUD && s.GEO_LONGITUD && parseFloat(s.GEO_LATITUD) !== 0) || s.TIPO === 'EX')
          .map(s => ({
            id: s.ID_SUCURSAL,
            nombre: s.SUCURSAL,
            servidor: s.IP_SERVIDOR,
            lat: s.TIPO === 'EX' ? null : parseFloat(s.GEO_LATITUD),
            lng: s.TIPO === 'EX' ? null : parseFloat(s.GEO_LONGITUD),
            tipo: s.TIPO
          }));
        setSucursalesBase(mapeadas);
      }
    } catch (error) {
      setMensajeError("Error al cargar sucursales.");
    }
  };

  // 2. RELOJ SEGUNDERO SINCRONIZADO
  useEffect(() => {
    const timer = setInterval(() => {
      setHora(new Date(Date.now() + desfase));
    }, 1000);
    return () => clearInterval(timer);
  }, [desfase]);

  // 3. SEGUIMIENTO DE GPS (Solo actualiza coordenadas)
  useEffect(() => {
    let watchId = null;
    if (modo === "sucursales") {
      if (process.env.REACT_APP_GEO_DUMMY==="S") {
        setUbicacionActual({
          lat: -17.378575,
          lng: -66.159491
        });
        setMensajeError("");
      } else {
        if (!navigator.geolocation) {
          setMensajeError("GPS no soportado.");
          return;
        }
        watchId = navigator.geolocation.watchPosition(
          (pos) => {
            setUbicacionActual({
              lat: pos.coords.latitude,
              lng: pos.coords.longitude
            });
            setMensajeError("");
          },
          (err) => setMensajeError("Activa el GPS para poder marcar."),
          { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
        );
      }
    }
    return () => { if (watchId !== null) navigator.geolocation.clearWatch(watchId); };
  }, [modo]);

  // 4. CÁLCULO DE DISTANCIAS (Se dispara solo si cambia la ubicación)
  useEffect(() => {
    if (!ubicacionActual || sucursalesBase.length === 0) return;

    const actualizadas = sucursalesBase.map((suc) => {
        
      // Las sucursales externas no tienen coordenadas,
        // por lo tanto siempre están disponibles.
        if (suc.tipo === "EX") {
          return {
            ...suc,
            distanciaTexto: "Externo",
            estaCerca: true,
            esExterna: true
          };
        }

      const dist = calcularDistancia(ubicacionActual.lat, ubicacionActual.lng, suc.lat, suc.lng);
      return {
        ...suc,
        distanciaTexto: dist > 1000 ? `${(dist / 1000).toFixed(1)} km.` : `${Math.round(dist)} m.`,
        estaCerca: dist <= 30, // Margen de 40m para evitar rebotes de señal
      };
    });
    setSucursalesCalculadas(actualizadas);
  }, [ubicacionActual, sucursalesBase]);

  const calcularDistancia = (lat1, lon1, lat2, lon2) => {
    if (!lat1 || !lon1 || !lat2 || !lon2) return Infinity;
    const R = 6371000;
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
              Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) *
              Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  };

  const pedirTexto = () => {
    return new Promise((resolve) => {
        setResolverDialogo(() => resolve);
        setTextoDialogo("");
        setMostrarDialogo(true);
    });
};


  // 5. ENVÍO DE MARCACIÓN CON COORDENADAS (Para validación en el Backend)
  const enviarMarcacion = async (sucursal) => {
    if (!ubicacionActual) return alert("Esperando señal de GPS...");
    
    try {
      const idEmpleado = ReactSession.get("idSession");
      const cargoEmpleado = ReactSession.get("cargo");
      const idModulo = 145; 
      const codigoMarca = tipoMarca === "INGRESO" ? "I" : "S";
      var observacionesAEnviar = `Marcado web en ${sucursal.nombre}`

      if(sucursal.tipo === 'EX' ){
        let texto = 'Se marcó la salida';
        if(codigoMarca === 'I'){
            texto = '';
            texto = await pedirTexto();
        }
        if (!texto || texto.trim() === "") {
            alert(
                `❌ El texto no puede estar vacio. Intente nuevamente.`
            );
            return;
          }
          observacionesAEnviar = texto.trim(); 
      }

      const response = await fetch(`${server}/api/asistencia/marcar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          idEmpleado,
          cargoEmpleado,
          idSucursal: sucursal.id,
          tipo: codigoMarca,
          sucursalTipo: sucursal.tipo,
          latUsuario: sucursal.tipo === "EX"
                    ? null
                    : ubicacionActual.lat,

                lngUsuario: sucursal.tipo === "EX"
                    ? null
                    : ubicacionActual.lng,
          observaciones: observacionesAEnviar,
          observacionesSeguimiento: ubicacionActual && (ubicacionActual.lat.toString() + ',' + ubicacionActual.lng.toString()),
          idModulo,
          ipservidor: sucursal.servidor,
          idregional: Number(JSON.parse(localStorage.getItem("info")).ID_REGIONAL_ACTUAL)
        }),
      });

     const data = await response.json();

     if (data.success !== true) {
      alert("❌ " + data.mensaje);
      return;
     }

     if (data.requiereCodigo) {

        // Guardamos el proceso pendiente
        setProcesoMarcacion({
            idProceso: data.idProceso,
            sucursal: sucursal
        });

        // Abrimos modal para introducir código
        setMostrarCodigo(true);

        return; // MUY IMPORTANTE
    }

      /**if (data.success) {
        // Creamos un mensaje dinámico dependiendo de si hay atraso o no
        let mensajeAtraso = "";
        let mensajeAtrasoAcumulado = "";

        if (data.atraso > 0) {
            mensajeAtraso = `\n⚠️ Atraso de Hoy: ${data.atraso} minutos`;
        } else {
            mensajeAtraso = `\n✨ Puntual o sin atraso hoy`;
        }
        if (data.minutosacumulados > 0) {
            mensajeAtrasoAcumulado = `\n⚠️ Atrasos acumulados: ${data.minutosacumulados} minutos`;
        } else {
            mensajeAtrasoAcumulado = `\n✨ Sin atrasos acumulados`;
        }

        alert(`✅ Registro exitoso\n Observaciones: ${data.mensaje} \nHora Servidor: ${data.hora}${mensajeAtraso} ${mensajeAtrasoAcumulado}`);
        
        setModo("principal");
      } 
      else {
          // Si existe data.mensaje lo muestra (caso de validación), 
          // si no, muestra data.error (caso de error de base de datos)
          const mensajeError = data.mensaje || data.error || "Ocurrió un error inesperado";
          alert(`❌ ${mensajeError}`);
      }*/
    } catch (error) {
      alert("Error al conectar con el servidor de marcas.");
    }
  };

  const confirmarMarcacion = async () => {
      try {

          const response = await fetch(
              `${server}/api/asistencia/confirmar-marcacion`,
              {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                      idProceso: procesoMarcacion.idProceso,
                      codigo: codigoConfirmacion
                  })
              }
          );

          const data = await response.json();

          if (!data.success) {

            if (data.codigoIncorrecto) {
                 setIntentos(intentos-1);

            if (intentos === 0) {
                alert("❌ PIN incorrecto. No se pudo registrar la asistencia.");
                  setMostrarCodigo(false);
                  setCodigoConfirmacion("");
                  setProcesoMarcacion(null);
                  setModo("principal");
                return;
            }

            alert(
                `❌ PIN incorrecto. Intente nuevamente.\n` +
                `Te quedan ${intentos} intento(s).`
            );

            // Aquí NO eliminas procesoMarcacion
            // NO cambias idProceso
            // Simplemente vuelves a mostrar el modal
            setCodigoConfirmacion("");
            setMostrarCodigo(true);

            return;
        }

              alert(`❌ ${data.mensaje}`);
              return;
          }

          let mensajeAtraso = "";

          if (data.atraso > 0) {
              mensajeAtraso =
                  `\n⚠️ Atraso de Hoy: ${data.atraso} minutos`;
          } else {
              mensajeAtraso =
                  `\n✨ Puntual o sin atraso hoy`;
          }

          let mensajeAtrasoAcumulado = "";

          if (data.minutosacumulados > 0) {
              mensajeAtrasoAcumulado =
                  `\n⚠️ Atrasos acumulados: ${data.minutosacumulados} minutos`;
          } else {
              mensajeAtrasoAcumulado =
                  `\n✨ Sin atrasos acumulados`;
          }

          alert(
              `✅ Registro exitoso\n` +
              `Observaciones: ${data.mensaje}\n` +
              `Hora Servidor: ${data.hora}` +
              mensajeAtraso +
              mensajeAtrasoAcumulado
          );

          setMostrarCodigo(false);
          setCodigoConfirmacion("");
          setProcesoMarcacion(null);

          setModo("principal");

      } catch (error) {

          console.error(error);

          alert("Error al conectar con el servidor.");
      }
  };

  // --- RENDERIZADO ---
  if (cargando) return <div style={{display:'flex', justifyContent:'center', alignItems:'center', height:'100vh'}}>Sincronizando con el servidor...</div>;

  // Estilos (se mantienen los tuyos)
  const styles = {
    layout: { height: "94vh", backgroundColor: "#9b9b9b", fontFamily: "'Segoe UI', sans-serif", display: "flex", flexDirection: "column", overflow: "hidden" },
    container: { flex: 1, padding: "20px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" },
    horaBig: { fontSize: "55px", fontWeight: "700", color: "#000", marginBottom: "5px" },
    sucursalCard: (cerca) => ({
      backgroundColor: "#fff", padding: "12px", borderRadius: "12px", display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px",
      borderLeft: cerca ? "6px solid #28a745" : "6px solid #dc3545", opacity: cerca ? 1 : 0.8, cursor: cerca ? "pointer" : "not-allowed", boxShadow: "0 2px 5px rgba(0,0,0,0.1)"
    }),
    btnBig: { height: "150px", width: "100%", maxWidth: "200px", borderRadius: "20px", border: "none", backgroundColor: "#fff", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", cursor: "pointer" }
  };

  const formatearHora = (f) => f.toLocaleTimeString("es-BO", { hour12: false });
  const formatearFecha = (f) => f.toLocaleDateString("es-BO", { weekday: "long", day: "2-digit", month: "long", year: "numeric" });

  if (modo === "sucursales") {
    return (
      <div style={styles.layout}>
        <div style={{ backgroundColor: tipoMarca === "INGRESO" ? "#007bff" : "#ff4500", padding: "15px", color: "white", textAlign: "center", fontWeight: "bold" }}>
          <span style={{ float: "left", cursor: "pointer" }} onClick={() => setModo("principal")}>⬅ Volver</span>
          MARCAR {tipoMarca}
        </div>
        <main style={{ ...styles.container, justifyContent: "flex-start", overflowY: "auto" }}>
          <div style={{ ...styles.horaBig, fontSize: "40px", marginTop: "20px" }}>{formatearHora(hora)}</div>
          <p style={{ color: "#333", fontSize: "13px", marginBottom: "20px" }}>Selecciona sucursal (Rango: 30m)</p>

          {mensajeError && <div style={{ backgroundColor: "#ffdee0", color: "#d32f2f", padding: "10px", borderRadius: "8px", marginBottom: "15px" }}>{mensajeError}</div>}

          <div style={{ width: "100%", maxWidth: "450px" }}>
            {sucursalesCalculadas.map((suc) => (
              <div key={suc.id} style={styles.sucursalCard(suc.estaCerca || suc.tipo === "EX")} onClick={() => (suc.estaCerca || suc.tipo === "EX") && enviarMarcacion(suc)}>
                <div>
                  <div style={{ fontWeight: "bold", fontSize: "14px" }}>{suc.nombre}</div>
                  {/*<div style={{ fontSize: "11px", color: suc.estaCerca ? "#28a745" : "#666" }}>
                    {suc.estaCerca ? "● Estás en el sitio" : "● Fuera de rango"}
                  </div>*/}

                  <div
                    style={{
                      fontSize: "11px",
                      color:
                        suc.tipo === "EX"
                          ? "#007bff"
                          : suc.estaCerca
                            ? "#28a745"
                            : "#666"
                    }}
                  >
                    {suc.tipo === "EX"
                      ? "● Lugar externo"
                      : suc.estaCerca
                        ? "● Estás en el sitio"
                        : "● Fuera de rango"}
                  </div>

                </div>
                {/*<div style={{ backgroundColor: suc.estaCerca ? "#28a745" : "#666", color: "white", padding: "5px 10px", borderRadius: "6px", fontSize: "12px", fontWeight: "bold" }}>
                  {suc.distanciaTexto || "---"}
                </div>*/}

                <div
                  style={{
                    backgroundColor:
                      suc.tipo === "EX"
                        ? "#007bff"
                        : suc.estaCerca
                          ? "#28a745"
                          : "#666",
                    color: "white",
                    padding: "5px 10px",
                    borderRadius: "6px",
                    fontSize: "12px",
                    fontWeight: "bold"
                  }}
                >
                  {suc.tipo === "EX"
                    ? "EXTERNO"
                    : suc.distanciaTexto || "---"}
                </div>
              </div>
            ))}
          </div>
        </main>
           {mostrarDialogo && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
              padding: "20px",
              boxSizing: "border-box"
            }}
          >

            <div
              style={{
                backgroundColor: "white",
                borderRadius: "15px",
                padding: "20px",
                width: "100%",
                maxWidth: "500px",
                boxSizing: "border-box",
                boxShadow: "0 5px 20px rgba(0,0,0,0.3)"
              }}
            >

              <h3 style={{ marginTop: 0 }}>
                ¿Dónde estás marcando?
              </h3>

              <p style={{ color: "#555" }}>
                Por favor describe el lugar donde marcas asistencia
              </p>

              <textarea
                value={textoDialogo}
                onChange={(e) => setTextoDialogo(e.target.value)}
                placeholder="Escriba aquí la observación..."
                rows={10}
                autoFocus
                style={{
                  width: "100%",
                  resize: "vertical",
                  boxSizing: "border-box",
                  padding: "10px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  fontFamily: "inherit",
                  fontSize: "14px",
                  outline: "none"
                }}
              />

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                  marginTop: "15px"
                }}
              >

                <button
                  onClick={() => {
                    setMostrarDialogo(false);

                    if (resolverDialogo) {
                      resolverDialogo("");
                    }
                  }}
                  style={{
                    padding: "10px 20px",
                    border: "none",
                    borderRadius: "8px",
                    backgroundColor: "#777",
                    color: "white",
                    cursor: "pointer"
                  }}
                >
                  Cancelar
                </button>

                <button
                  onClick={() => {
                    setMostrarDialogo(false);

                    if (resolverDialogo) {
                      resolverDialogo(textoDialogo);
                    }
                  }}
                  style={{
                    padding: "10px 20px",
                    border: "none",
                    borderRadius: "8px",
                    backgroundColor:
                      tipoMarca === "INGRESO"
                        ? "#007bff"
                        : "#ff4500",
                    color: "white",
                    cursor: "pointer",
                    fontWeight: "bold"
                  }}
                >
                  Enviar
                </button>

              </div>

            </div>

          </div>
        )}
        {mostrarCodigo && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 10000,
                padding: "20px",
                boxSizing: "border-box"
              }}
            >
              <div
                style={{
                  backgroundColor: "white",
                  borderRadius: "15px",
                  padding: "25px",
                  width: "100%",
                  maxWidth: "400px",
                  boxSizing: "border-box",
                  boxShadow: "0 5px 20px rgba(0,0,0,0.3)"
                }}
              >

                <h3
                  style={{
                    marginTop: 0,
                    marginBottom: "10px",
                    textAlign: "center"
                  }}
                >
                  Confirmar marcación
                </h3>

                <p
                  style={{
                    color: "#555",
                    textAlign: "center",
                    marginBottom: "20px"
                  }}
                >
                  Ingrese el código de confirmación
                </p>

                <input
                  type="number"
                  value={codigoConfirmacion}
                  onChange={(e) => setCodigoConfirmacion(e.target.value)}
                  placeholder="Código"
                  autoFocus
                  style={{
                    width: "100%",
                    boxSizing: "border-box",
                    padding: "12px",
                    borderRadius: "8px",
                    border: "1px solid #ccc",
                    fontSize: "18px",
                    textAlign: "center",
                    outline: "none"
                  }}
                />

                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                    marginTop: "20px"
                  }}
                >

                  <button
                    onClick={() => {
                      setMostrarCodigo(false);
                      setCodigoConfirmacion("");
                      setProcesoMarcacion(null);
                    }}
                    style={{
                      padding: "10px 20px",
                      border: "none",
                      borderRadius: "8px",
                      backgroundColor: "#777",
                      color: "white",
                      cursor: "pointer"
                    }}
                  >
                    Cancelar
                  </button>

                  <button
                    onClick={confirmarMarcacion}
                    style={{
                      padding: "10px 20px",
                      border: "none",
                      borderRadius: "8px",
                      backgroundColor:
                        tipoMarca === "INGRESO"
                          ? "#007bff"
                          : "#ff4500",
                      color: "white",
                      cursor: "pointer",
                      fontWeight: "bold"
                    }}
                  >
                    Confirmar
                  </button>

                </div>
              </div>
            </div>
          )}
      </div>
    );
  }

  return (
    <div style={styles.layout}>
      <main style={styles.container}>
        <div style={{ textAlign: "center", marginBottom: "30px" }}>
          <div style={{ color: "#000", fontSize: "18px", textTransform: "uppercase" }}>{formatearFecha(hora)}</div>
          <div style={styles.horaBig}>{formatearHora(hora)}</div>
          <p style={{ color: "#444", fontSize: "14px" }}>Hora oficial del servidor</p>
        </div>
        <h3 style={{ color: "#000", marginBottom: "30px", fontWeight: "400" }}>¿Qué desea registrar hoy?</h3>
        <div style={{ display: "flex", gap: "20px", width: "100%", justifyContent: "center" }}>
          <button style={{ ...styles.btnBig, color: "#007bff" }} onClick={() => { setTipoMarca("INGRESO"); setModo("sucursales"); }}>
            <span style={{ fontWeight: "bold" }}>INGRESO</span>
          </button>
          <button style={{ ...styles.btnBig, color: "#ff4500" }} onClick={() => { setTipoMarca("SALIDA"); setModo("sucursales"); }}>
            <span style={{ fontWeight: "bold" }}>SALIDA</span>
          </button>
        </div>
      </main>
    </div>
  );
}